// src/pages/PrivacyPolicyPage.tsx

import { LegalPageLayout } from "../components/common/LegalPageLayout";
import { APP_CONFIG } from '../config/constants';

export default function PrivacyPolicyPage() {
    const lastUpdated = "11 de Outubro de 2025";
    // Gera um e-mail padrão para privacidade a partir do nome da loja (sanitizado)
    const privacyEmail = `suporte@${APP_CONFIG.storeName
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '')
        .toLowerCase()
        .replace(/[^a-z0-9]/g, '')}.com.br`;

    return (
        <LegalPageLayout title="Política de Privacidade">
            <p className="font-semibold">Última atualização: {lastUpdated}</p>
            <p>
                A sua privacidade é importante para nós. Esta Política de Privacidade explica como a {APP_CONFIG.storeName} coleta, usa, e protege suas informações pessoais.
            </p>

            <h2 className="text-2xl font-bold text-text-primary pt-4">1. Informações que Coletamos</h2>
            <p>
                Coletamos informações que você nos fornece diretamente, como:
            </p>
            <ul className="list-disc list-inside space-y-2 pl-4">
                <li><strong>Informações da Conta:</strong> Seu nome de usuário, endereço de e-mail e senha (criptografada) quando você se registra.</li>
                <li><strong>Informações de Transação:</strong> Detalhes sobre as compras que você faz, embora não armazenemos os dados completos do seu cartão de crédito.</li>
                <li><strong>Comunicações:</strong> Quando você entra em contato com nosso suporte.</li>
            </ul>

            <h2 className="text-2xl font-bold text-text-primary pt-4">2. Como Usamos Suas Informações</h2>
            <p>
                Utilizamos suas informações para:
            </p>
            <ul className="list-disc list-inside space-y-2 pl-4">
                <li>Fornecer, manter e melhorar nossos serviços.</li>
                <li>Processar transações e enviar informações relacionadas, como confirmações de compra.</li>
                <li>Responder aos seus comentários, perguntas e solicitações de suporte.</li>
                <li>Comunicar sobre produtos, serviços e eventos.</li>
            </ul>

            <h2 className="text-2xl font-bold text-text-primary pt-4">3. Compartilhamento de Informações</h2>
            <p>
                Não compartilhamos suas informações pessoais com terceiros, exceto nas seguintes circunstâncias:
            </p>
            <ul className="list-disc list-inside space-y-2 pl-4">
                <li>Com provedores de serviços que precisam de acesso para realizar trabalhos em nosso nome (ex: gateways de pagamento).</li>
                <li>Em resposta a uma solicitação de informações se acreditarmos que a divulgação está de acordo com qualquer lei, regulamento ou processo legal aplicável.</li>
                <li>Se acreditarmos que suas ações são inconsistentes com nossos acordos de usuário ou políticas, ou para proteger os direitos, propriedade e segurança da {APP_CONFIG.storeName} ou de outros.</li>
            </ul>

            <h2 className="text-2xl font-bold text-text-primary pt-4">4. Seus Direitos</h2>
            <p>
                Você tem o direito de acessar, corrigir ou excluir suas informações pessoais. Você pode gerenciar as informações da sua conta fazendo login no seu perfil ou entrando em contato conosco.
            </p>

            <h2 className="text-2xl font-bold text-text-primary pt-4">5. Contato</h2>
            <p>
                Se você tiver alguma dúvida sobre esta Política de Privacidade, entre em contato conosco pelo e-mail: <a href={`mailto:${privacyEmail}`} className="text-brand-blue hover:underline">{privacyEmail}</a>.
            </p>
        </LegalPageLayout>
    );
}